





























import { Component, Mixins } from "vue-property-decorator";
import AxiosMixin from "@/mixins/axiosMixin";
import AppAuthButton from "@/components/admin_common/AppAuthButton.vue";
import { CauseMeasure } from "@/views/biaggregate/types";
import CauseMeasureList from "@/components/biaggregate/causemeasure/CauseMeasureList.vue";
@Component({
  components: {
    AppAuthButton,
    CauseMeasureList,
  },
})
export default class extends Mixins(AxiosMixin) {
  /** 主因仮説/打ち手コメントマスタ */
  private causeMeasures: CauseMeasure[] = [];

  created(): void {
    this.fetch();
  }

  /** 主因仮説/打ち手コメントマスタ取得 */
  private fetch(): void {
    this.postJsonCheck(
      window.base_url + "/api/admin/biaggregate/causemeasures/get",
      {},
      (res) => {
        this.causeMeasures = res.data.cause_measures ?? [];
      }
    );
  }

  /** 編集画面へ遷移 */
  private moveToEditPage(id: number) {
    this.$router.push({ path: "/biaggregate/causemeasure/edit/" + id });
  }
}
